import React, { Fragment } from 'react';
import queryString from 'query-string';
import validator from 'validator';
import _ from 'lodash';
import {
  Popup,
  EditableComponent,
  Loading,
  InputField,
} from 'arteia-js/components';
import { API } from 'arteia-js/services';
import getUTMParams from '../getUTMParams';
import { backgroundArtworks } from '../configs/backgroundArtworks.config';

var artwork =
  backgroundArtworks[Math.floor(Math.random() * backgroundArtworks.length)];
class SignUp extends EditableComponent {
  state = {
    registerErrored: false,
    registering: false,
    registerSuccessful: false,
    errorMessage: '',
    email: '',
    fullname: '',
    passwordA: '',
    passwordB: '',
  };

  componentDidMount() {
    const urlParams = new URLSearchParams(window.location.search);
    const email = urlParams.get('email');
    if (email) {
      this.setState({ email });
    }
  }

  staticTexts = {
    weakPassword:
      'Password should be at least 8 characters long and contain at least 1 number and 1 letter',
    differentPasswords: 'Passwords do not match',
  };

  registerConfirm = () => {
    const { email, passwordA: password, fullname: fullName } = this.state;
    const { inputsFilled, strongPassword, passwordsSame, emailCorrect } =
      this.isDataCorrect();
    const allowSave =
      inputsFilled && strongPassword && passwordsSame && emailCorrect;

    if (!allowSave) {
      return this.setState({
        registerErrored: true,
      });
    }

    this.setState({
      registering: true,
      registerErrored: false,
      registerSuccessful: false,
    });

    return API.post('/sign-up', {
      email,
      password,
      fullName,
      utmParams: getUTMParams(this.props.location),
    })
      .then((res) => {
        this.setState({
          registering: false,
          registerSuccessful: true,
        });

        const { planId, returnTo } = queryString.parse(
          this.props.location.search
        );

        console.log('queryString', queryString);
        console.log('returnTo', returnTo);

        if (returnTo === 'connect') {
          setTimeout(() => {
            const query = {
              token: res.token,
              returnTo: 'accounts-client-2-0/welcome-to-connect',
            };
            window.location.assign(`/redirect?${queryString.stringify(query)}`);
          }, 1500);
        } else {
          setTimeout(() => {
            const query = {
              token: res.token,
              returnTo: planId
                ? `accounts-client/collections/new?planId=${planId}&period=1`
                : 'accounts-client/welcome',
            };
            window.location.assign(`/redirect?${queryString.stringify(query)}`);
          }, 1500);
        }
      })
      .catch((err) => {
        const { status, response } = err;
        const { data = {} } = _.get(response, 'body', {});

        let message = 'Something went wrong. Try again in few minutes.';

        if (
          status === 400 &&
          data.fieldErrors &&
          data.fieldErrors['user.email']
        ) {
          const code = _.get(data.fieldErrors['user.email'], '0.code');
          if (code === '[duplicate]user.email') {
            message =
              'A user with this email already exists. If you’ve already created an account for another Arteïa product you can log in using the same email and password.';
          }
        }

        this.setState({
          registering: false,
          registerErrored: true,
          errorMessage: message,
        });
      });
  };

  handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      this.registerConfirm();
    }
  };

  isDataCorrect = () => {
    const { email, passwordA, passwordB } = this.state;

    const inputsFilled = passwordA.length !== 0 && passwordB.length !== 0;

    const strongPassword =
      passwordA.length > 7 &&
      /\d/.test(passwordA) &&
      /[a-zA-Z]/.test(passwordA);

    const passwordsSame = passwordA === passwordB;

    const emailCorrect = validator.isEmail(email);

    return {
      inputsFilled,
      strongPassword,
      passwordsSame,
      emailCorrect,
    };
  };

  pathName() {
    return window.location.pathname + window.location.search;
  }

  goBackToLoginPage = () => {
    const { history } = this.props;
    if (this.pathName() === '/sign-up-to?returnTo=connect') {
      history.push('/?returnTo=connect');
    } else {
      history.push('/?returnTo=collect');
    }
  };

  render() {
    const {
      registerSuccessful,
      registerErrored,
      registering,
      errorMessage,
      email,
      passwordA,
      passwordB,
    } = this.state;

    const { strongPassword, passwordsSame, emailCorrect } =
      this.isDataCorrect();

    return (
      <div className='signup-modal-wrapper'>
        <img src={artwork.asset} />
        <div className='artwork-details'>
          <span className='artist-name'>{artwork.artistName}</span>
          <br />
          <span className='artwork-title'>
            {artwork.title}, {artwork.year}
          </span>
        </div>
        <span className='all-rights-reserved'>
          &copy; {new Date().getFullYear()} Arteïa - All rights reserved
        </span>
        <Popup size='form' noTitle noCloseHandler className='signup-modal form'>
          <h1>Create a Free Account</h1>
          <div>
            {!registerErrored && registerSuccessful ? (
              <div className='popup-content'>
                <div className='email-sent'>
                  <i className='icon-icon_ok' />
                  <h1>Success</h1>
                  <p className='text-center'>
                    Your account was successfully registered.
                  </p>
                  <p className='muted text-center'>Redirecting...</p>
                </div>
              </div>
            ) : (
              <div className='signup-wrapper'>
                <div className='form-wrapper'>
                  <div className='signup-form'>
                    {registering && (
                      <div className='text-center'>
                        <Loading />
                      </div>
                    )}

                    {!registering && (
                      <Fragment>
                        <span className='input-label'>Email</span>
                        <InputField
                          value={email}
                          autoFocus
                          hasErrored={registerErrored && !emailCorrect}
                          errorMessage={
                            email.length
                              ? 'Sorry, but that email is invalid'
                              : 'Please enter a value'
                          }
                          onChange={this.onFieldChange('email')}
                        />

                        <span className='input-label'>Password</span>
                        <InputField
                          value={passwordA}
                          type={'password'}
                          hasErrored={registerErrored && !strongPassword}
                          errorMessage={this.staticTexts.weakPassword}
                          onChange={this.onFieldChange('passwordA')}
                        />

                        <span className='input-label'>Confirm password</span>
                        <InputField
                          value={passwordB}
                          type={'password'}
                          hasErrored={registerErrored && !passwordsSame}
                          errorMessage={this.staticTexts.differentPasswords}
                          onChange={this.onFieldChange('passwordB')}
                          handleKeyPress={this.handleKeyPress}
                        />

                        <div className='form-msg'>
                          <span className='error-msg'>
                            {registerErrored && errorMessage}
                          </span>
                        </div>
                      </Fragment>
                    )}
                  </div>
                  <div className='signup-info'>
                    <div className='info-box'>
                      <span>
                        Password should be at least 8 characters <br />
                        long and contain at least 1 number and 1 letter
                      </span>
                    </div>
                  </div>
                </div>
                <div className='signup-btns'>
                  {!registering && (
                    <div className='help-msg msg-register'>
                      By registering you agree to our &nbsp;
                      <a
                        href='/terms.html'
                        target='_blank'
                        className='art-link-underline'
                      >
                        Terms and Conditions
                      </a>
                    </div>
                  )}
                  <button
                    id={
                      this.pathName() === '/sign-up-to?returnTo=connect'
                        ? 'connect-btn'
                        : ''
                    }
                    className='art-btn'
                    onClick={this.registerConfirm}
                  >
                    Create an Account
                  </button>
                  <a
                    className='secondary-a'
                    onClick={() => this.goBackToLoginPage()}
                  >
                    I already have an account
                  </a>
                </div>
              </div>
            )}
          </div>
        </Popup>
      </div>
    );
  }
}

SignUp.propTypes = {};
SignUp.defaultProps = {};

export default SignUp;



// WEBPACK FOOTER //
// ./src/scenes/SignUp/index.js